import { apiClient, BASE_URL, AUTH_HEADER } from '../utils/ApiClient';

export const fetchAllCourses = async () => {
    return apiClient.get(`${BASE_URL}/courses`);
}

export const fetchCourse = async (id: number) => {
    return apiClient.get(`${BASE_URL}/courses/${id}`);
}

export const addCourse = async (params: any) => {
    return apiClient.post(`${BASE_URL}/courses`, params);
}

export const updateCourse = async (id: number, params: any) => {
    return apiClient.put(`${BASE_URL}/courses/${id}`, params);
}

export const deleteCourse = async (id: number) => {
    return apiClient.delete(`${BASE_URL}/courses/${id}`);
}

export const fetchCourseInfo = async (id: number) => {
    return apiClient.get(`${BASE_URL}/courses/${id}/course_info`);
}

export const addCourseInfo = async (id: number, params: any) => {
    return apiClient.post(`${BASE_URL}/courses/${id}/course_info`, params);
}

export const updateCourseInfo = async (id: number, courseInfoId: number, params: any) => {
    return apiClient.put(`${BASE_URL}/courses/${id}/course_info/${courseInfoId}`, params);
}

export const fetchCourseChats = async (id:number) => {
    return apiClient.get(`${BASE_URL}/courses/${id}/chats`);
}

export const addCourseChats = async (id: number, params: any) => {
    return apiClient.post(`${BASE_URL}/courses/${id}/chats`, params);
}

export const fetchModes = async () => {
    return apiClient.get(`${BASE_URL}/modes`);
}

export const fetchLLMs = async () => {
    return apiClient.get(`${BASE_URL}/llms`);
}

export const fetchMessage = async (id: number, chatId: number) => {
    return apiClient.get(`${BASE_URL}/courses/${id}/chats/${chatId}/messages`);
}

export const addMessage = async (id: number, chatId: number, params: any) => {
    return apiClient.post(`${BASE_URL}/courses/${id}/chats/${chatId}/messages`, params);
}

export const deleteMessage = async (id: number, chatId: number, messageId: number) => {
    return apiClient.delete(`${BASE_URL}/courses/${id}/chats/${chatId}/messages/${messageId}`);
}

export const updateMessage = async (id: number, chatId: number, messageId: number, params: any) => {
    return apiClient.put(`${BASE_URL}/courses/${id}/chats/${chatId}/messages/${messageId}`, params);
}

export const fetchChatCategories = async (id: number, chatId: number) => {
    return apiClient.get(`${BASE_URL}/courses/${id}/chats/${chatId}/categories`);
}

export const addChatCategories = async (id: number, chatId: number, message: any) => {
    return apiClient.post(`${BASE_URL}/courses/${id}/chats/${chatId}/categories`, message);
}